import React from "react";
import { Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";

import { VALIDATIONS, VALIDATIONS_TEXT } from "../../utils/Validations";
import CustomInput from "../Defaut/CustomInput";

import FooterImage from "../../assets/images/Home/footer_image.png";
import { useNavigate } from "react-router-dom";

const JoinWaitlist = () => {
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
  } = useForm({ mode: "onChange" });
  const onSubmit = (data) => {
    // console.log(data);
  };
  return (
    <>
      {/* <div className="d-flex justify-content-center align-items-center h-100">
        <img src={FooterImage} alt="" width={"90%"} />
      </div> */}

      <div className="joinwaitlist-component container" id="about-us">
        <h1>Start building stronger relationships today.</h1>
        <h5 className="mb-4 mt-3">
          Bring your profiles, notes, conversations, calendar, and follow-ups into one intelligent relationship hub. Download Socius and stay connected with more clarity, context, and confidence.
        </h5>
        {/* <Form onSubmit={handleSubmit(onSubmit)}> */}
        <div className="mt-3 email">
          <button type="button" className="email-button" onClick={() => navigate("/contact-us")}>
            Get Started Now
          </button>
          {/* <Controller
              control={control}
              name="email"
              rules={{
                required: {
                  value: true,
                  message: VALIDATIONS_TEXT.EMAIL_REQUIRED,
                },
                maxLength: {
                  value: VALIDATIONS.EMAIL,
                  message: VALIDATIONS_TEXT.EMAIL,
                },
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: VALIDATIONS_TEXT.EMAIL_FORMAT,
                },
              }}
              render={({ field }) => (
                <div className="input-wrapper">
                  <CustomInput
                    {...field}
                    label="Enter Email"
                    placeholder="Enter Email"
                    type="email"
                    className="name"
                    required={true}
                    maxLength={VALIDATIONS.EMAIL}
                    value={field.value}
                    onChange={field.onChange}
                  />

                </div>
              )}
            /> 
            */}
        </div>
        {/* </Form > */}
        {/* <Button className="btn-theme-default btn-contact-us">
          contact Us
        </Button> */}
      </div >
    </>
  );
};
export { JoinWaitlist };
